// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"7813":"organization-detail","8386":"order-detail"}[chunkId] + "." + {"7813":"40a551a3","8386":"f2736fae"}[chunkId] + ".css";
};